import Vue from 'vue/dist/vue.min.js';
import tippy from 'tippy.js';
import VModal from 'vue-js-modal';
import { tooltipModal } from "./modals";
Vue.use(VModal);

const Timeline = () => {

    let timelineItems = document.querySelectorAll('.timeline');

    let timelineConstructor = (id) => {
        Vue.component('timeline', {
            data: function() {
                return {
                    isMobile: null,
                    instance: null
                }
            },
            methods: {
                initIsMobile() {
                    // console.log("calc this", window.innerWidth);
                    // note this is checking for a smaller screen size than the isMobile value in the vuex store
                    var mql = window.matchMedia('(max-width: 650px)');
                    this.isMobile = mql.matches ? true : false;

                    mql.addEventListener('change',() => {
                        this.isMobile = mql.matches ? true : false;
                    });
                }
            },
            mounted() {
                this.initIsMobile();
            }
        });

        Vue.component('timeline-item', {
            props: ['isMobile'],
            data: function() {
                return {
                    message: {},
                    isOpen: null
                }
            },
            watch: {
                isMobile: function() {
                    if (this.isMobile) {
                        this.disableTooltips;
                    }
                }
            },
            methods: {
                initTippy() {
                    let self = this;

                    tippy(this.$refs.tooltip, {
                        allowHTML: true,
                        arrow: true,
                        hideOnClick: true,
                        trigger: 'click',
                        interactive: true,
                        zIndex: 99,
                        onShow(instance) {
                            // console.log("OPENED");
                            self.isOpen = true;
                        },
                        onHide(instance) {
                            self.isOpen = false;
                        }
                    })
                },
                mobileTooltip() {
                    if (this.isMobile) {
                        let content = `
                            <div class="timeline__item-date">${this.message.date}</div>
                            <div class="timeline__item-desc">${this.message.title}</div>
                            <div>${this.message.copy}</div>
                        `;

                        this.$modal.show(
                            tooltipModal.template(content),
                            tooltipModal.name,
                            tooltipModal.options
                        )
                    }
                },
                disableTooltips() {
                    let target = this.$refs.tooltip;
                    let instance = target._tippy;
                    instance.disable(); //@TODO: figure out why disable method isn't working
                },
                initMessageData() {
                    this.message.copy = this.$refs.tooltip.getAttribute('data-tippy-content');
                    this.message.title = this.$refs.desc.innerText;
                    this.message.date = this.$refs.date.innerText;
                }
            },
            mounted() {
                this.$nextTick(() => {
                    this.initTippy();
                    if (this.isMobile) {
                        this.disableTooltips();
                    } 
                });
                this.initMessageData();
            }
        })

        new Vue({
            el: `.timeline-${id}`,
        }).$mount(`.timeline-${id}`, true);
    }

    if (timelineItems.length > 0) {
        timelineItems.forEach((item, index) => {
            item.classList.add(`timeline-${index}`);
            timelineConstructor(index);
        })
    }

}

export default Timeline;